/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["is_completed"] }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import KeyprIcon from '@keypr/icon-font';
import { Link } from 'react-router-dom';
import { Checkbox } from 'material-ui';
import { List, ListItem } from 'material-ui/List';
import actions from '../../state/actions';
import Channel from '../../components/Channel';
import Priority from '../../components/Priority';
import AffiliateTime from '../../components/Filters/AffiliateTime';
import formUtils from '../../utils/forms';
import { workOrders as statusOptions } from '../../config/service-options';
import MultipleLocations from '../../components/MultipleLocations';
import Select from '../../components/Select';
import Tab from '../../components/Tab';
import AddAttachment from '../../containers/AddAttachment';
import SortPills from '../../components/SortPills';
import Comment from '../../components/Comment';
import Modal from '../../components/Modal';
import GenericFormItem from '../../components/GenericFormItem';
import StaffAvailability from '../../containers/StaffAvailability';
import Screen from '../../components/Screen';
import HasPermissions from '../../components/HasPermissions';
import { HistoryType } from '../../types/router';
import { localize, t } from '../../i18n';

import './WorkorderDetail.css';

const {
  ModalCaption,
  ModalImage,
} = Modal;

const AVAILABLE_TABS = [
  { tab: 'details', label: t('Details') },
  { tab: 'comments', label: t('Comments') },
  { tab: 'tasks', label: t('Tasks') },
];

class WorkorderDetail extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    // const activeTabInfo = _.find(AVAILABLE_TABS, { tab: 'details' });
    // if (activeTabInfo) {
    //   activeTab = activeTabInfo.tab;
    // }

    const {
      location: {
        state: {
          tab: activeTab = 'details',
        } = {},
      },
    } = this.props;

    this.state = {
      activeTab,
      status: this.props.workorder ? this.props.workorder.status : null,
      assigned: (this.props.workorder && this.props.workorder.assigned) ? this.props.workorder.assigned.id : null,
      form: {},
      formUpdated: false,
      updating: false,
      sortComments: 'desc',
      showCommentModal: false,
      modalInfo: {},
      tempComment: null,
      workorderLoaded: false,
      currentWorkOrderId: null,
    };
  }

  componentWillMount() {
    this.processWorkOrder();
  }

  componentDidMount() {
    document.body.dispatchEvent(new Event('workorder-details-mounted'));
  }

  componentWillReceiveProps(nextProps) {
    const activeTab = this.state.activeTab;

    // Do not go back to list on tasks update
    if (nextProps.actionType === 'API_UPDATED'
        && nextProps.lastAction.configType === 'workorder'
        && activeTab !== 'tasks'
    ) {
      this.goBackToList();
    }
    if (nextProps.actionType === 'API_READ') {
      const updateState = {};
      if (nextProps.lastAction.configType === 'workorder') {
        updateState.workorderLoaded = true;
      }
      this.setState(updateState);
    }
    if (nextProps.actionType === 'API_CREATED') {
      const updateState = {};
      if (nextProps.lastAction.configType === 'comments') {
        updateState.tempComment = null;
      }
      this.setState(updateState);
    }
    if (nextProps.actionType === 'API_UPDATE_FAILED' && nextProps.lastAction.configType === 'workorder') {
      this.setState({
        updating: false,
      });
    }
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(this.props.workorderId);
    }
    if (this.state.status === null && nextProps.actionType === 'API_READ' && nextProps.workorder) {
      this.setState({
        status: nextProps.workorder.status,
        assigned: (nextProps.workorder && nextProps.workorder.assigned) ? nextProps.workorder.assigned.id : null,
      });
    }
  }

  processWorkOrder() {
    this.setState({ currentWorkOrderId: this.props.workorderId }, () => {
      if (this.didProcessRequest === false) {
        this.didProcessRequest = true;
        this.props.processRequest(this.props.workorderId);
      }
      this.props.processResourceRequest(this.props.workorderId);
    });
  }

  goBackToList() {
    const { history } = this.props;

    history.push('/access/workorders');
  }

  handleChange(value, name, cb) {
    let status = this.state.status;
    let assigned = this.state.assigned;
    let formUpdated = this.state.formUpdated;
    const newFormValues = Object.assign({}, this.state.form);
    newFormValues[name] = value;

    // Reset form WO status if it is the same as initial WO status
    if (this.props.status === newFormValues.status) {
      newFormValues.status = undefined;
    }

    if (name === 'status') {
      if (
        ['new', 'acknowledged'].indexOf(status) === -1
        && ['new', 'acknowledged'].indexOf(value) !== -1
        && assigned !== null
      ) {
        assigned = null;
        newFormValues.assigned = assigned;
      }
      status = value;
      if (value !== 'assigned') {
        formUpdated = true;
      }
    }
    if (name === 'assigned') {
      assigned = value;
      const assignee = _.find(this.props.staffList, { id: value });
      if (assignee) {
        const assigneePayload = {
          id: assignee.id,
          full_name: `${assignee.first_name} ${assignee.last_name}`,
        };
        newFormValues[name] = assigneePayload;
        if (status === 'new' || status === 'acknowledged') {
          status = 'assigned';
          newFormValues.status = status;
        }
        formUpdated = true;
      } else if (value === null && status === 'assigned') {
        status = this.props.workorder.status;
      }
    }
    return this.setState({
      assigned,
      status,
      form: newFormValues,
      formUpdated,
    }, cb);
  }

  handleAddAttachments(attachments) {
    const comment = {
      text: attachments.description,
    };
    if (attachments.fileList.length > 0) {
      comment.attachment = attachments.fileList[0];
    }
    this.setState({
      tempComment: comment,
    }, () => {
      this.props.createWorkorderComment(this.props.workorderId, comment);
    });
  }

  validateAndUpdate(workorderId, form) {
    const {
      status,
      workorderTasks,
      notify,
    } = this.props;

    // Check if status transition is available
    if (workorderTasks) {
      const unfinishedTasks = workorderTasks.find(task => task.is_completed === false);
      const finishedTasks = workorderTasks.find(task => task.is_completed === true);

      // Prevent close work orders with unfinished tasks
      if (status === 'in_progress'
        && this.state.form.status === 'closed'
        && unfinishedTasks) {
        // Notify user about unfinished tasks
        notify(this.props.t('Unable to update Work Order. Some required checklist tasks are incomplete'), 'danger');

        // Set status back to 'in_progress'
        this.setState({ status: 'in_progress', updating: false, form: { ...form, status: undefined } });

        return false;
      }

      // Prevent start work order with finished tasks
      if (this.state.form.status === 'in_progress'
        && finishedTasks) {
        // Notify user about finished tasks
        notify(this.props.t('Work Order cannot be started with tasks in checked state'), 'danger');

        // Set status back to 'assigned'
        this.setState({ status: 'assigned', updating: false, form: { ...form, status: undefined } });

        return false;
      }

      if (this.state.form.status === 'new' && finishedTasks) {
        const uncheckedList = workorderTasks.map(task => ({ ...task, is_completed: false }));
        return this.props.updateWorkorder(workorderId, { ...form, checklist: uncheckedList });
      }
    }

    return this.props.updateWorkorder(workorderId, form);
  }

  handleSubmitTouchTap(evt) {
    evt.preventDefault();

    if (this.state.formUpdated === true) {
      this.setState({
        updating: true,
      });
      this.validateAndUpdate(this.props.workorderId, this.state.form);
    }
  }

  handleResourceViewChange(activeTab) {
    this.setState({ activeTab });
  }

  checkTask(task, isCompleted) {
    const {
      workorderTasks: tasks,
      status,
    } = this.props;

    task.is_completed = isCompleted;

    this.handleChange(tasks, 'checklist', () => {
      // Ignore WO status for tasks update
      const form = { ...this.state.form, status: undefined };

      this.setState({ form, status }, () => {
        this.validateAndUpdate(this.props.workorderId, this.state.form);
      });
    });
  }

  render() {
    const {
      activeTab,
      sortComments,
      showCommentModal,
      modalInfo,
      tempComment,
      workorderLoaded,
      currentWorkOrderId,
    } = this.state;
    const {
      workorderId,
      workorder,
      workorderComments,
      workorderTasks,
      channels,
      workorderConfigs,
      user,
      status,
      taskGroups,
    } = this.props;

    // Handle any new workorder if page component was not unmounted
    // for example new WO from push notification
    if (currentWorkOrderId && currentWorkOrderId !== workorderId) {
      this.processWorkOrder();
    }

    // eslint-disable-next-line
    let workorderDetail = (
      <div className="md-card">
        <div className="md-card-content" />
      </div>
    );
    let workorderDetailInfo = null;
    let workorderCommentsInfo = null;
    let workorderTasksInfo = null;
    let workorderFooterInfo = null;
    let modal = null;
    let comments = null;
    let sortedWorkorderComments = Object.assign([], workorderComments);
    if (sortComments === 'desc') {
      sortedWorkorderComments = sortedWorkorderComments.reverse();
    }

    if (workorderLoaded === true && workorder !== undefined && channels.length > 0 && workorderConfigs.length > 0) {
      workorder.dashboardColor = (_.find(channels, { name: workorder.channel }) || {}).dashboard_color;
      workorder.icon = (_.find(workorderConfigs, { work_order_name: workorder.type }) || {}).icon;
      const backgroundColorChart = {
        normal: 'md-card-bg-success',
        warning: 'md-card-bg-warning',
        critical: 'md-card-bg-danger',
      };
      const detailsCardCls = ['md-card'];
      if (workorder.severity in backgroundColorChart) {
        detailsCardCls.push(backgroundColorChart[workorder.severity]);
        // } else {
        //   detailsCardCls.push('md-card-bg-success');
      }

      const submitButtonDisabled = this.state.formUpdated === false;

      const assigneesOptions = _.map(this.props.staffList, staff => ({
        value: staff.id,
        label: (
          <div className="staff">
            <StaffAvailability userId={staff.id} isAvailable={staff.is_available} />
            <span>
              {staff.first_name} {staff.last_name}
            </span>
          </div>
        ),
      }));
      if (workorder.assigned && !_.find(assigneesOptions, { value: workorder.assigned.id })) {
        assigneesOptions.unshift({
          value: workorder.assigned.id,
          label: workorder.assigned.full_name,
        });
      }
      if (assigneesOptions.length > 0) {
        assigneesOptions.unshift({
          value: null,
          label: this.props.t('None'),
        });
      }

      const validStatusTransitions = _.filter(statusOptions, st => (workorder.valid_status_transitions.indexOf(st.value) !== -1));
      validStatusTransitions.unshift(_.find(statusOptions, { value: workorder.status }));

      if (assigneesOptions.length === 0) {
        const assignStatusId = _.findIndex(validStatusTransitions, { value: 'assigned' });
        validStatusTransitions[assignStatusId] = Object.assign({}, validStatusTransitions[assignStatusId], {
          disabled: true,
        });
      }

      let displayAssignee = this.props.t('None');
      if (this.state.assigned) {
        const currentAssignee = _.find(this.props.staffList, { id: this.state.assigned });
        if (currentAssignee) {
          displayAssignee = `${currentAssignee.first_name} ${currentAssignee.last_name}`;
        }
      }

      workorderDetailInfo = (
        <div className="form-detail">
          <GenericFormItem label={this.props.t('Location')}>
            <MultipleLocations locations={workorder.locations} />
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Type')}>
            <span>
              <span className="menu_icon"><KeyprIcon icon={workorder.icon} className="service-icon" /></span>
              {workorder.label || ''}
            </span>
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Priority')}>
            <Priority priority={workorder.priority} />
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Summary')}>
            {workorder.summary || ''}
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Description')}>
            {workorder.description || ''}
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Due')}>
            <AffiliateTime time={workorder.due_date} mask="hh:mm A MM/DD/YY" />
          </GenericFormItem>
          {formUtils.getFormItems({
            body: workorder.body,
            type: workorder.type,
            configs: workorderConfigs,
            title: 'work_order_name',
          })}
          <GenericFormItem label={this.props.t('Submitted')}>
            <AffiliateTime time={workorder._created} mask="hh:mm A MM/DD/YY" />
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Status')}>
            <HasPermissions
              permissions="work_orders.update"
              or={() => <span>{this.state.status}</span>}
            >
              <Select
                name="form-field-name"
                value={this.state.status}
                options={validStatusTransitions.map(o => (
                  {
                    ...o,
                    label: this.props.t(o.label),
                  }
                ))}
                onChange={value => this.handleChange(value, 'status')}
                clearable={false}
                openAfterFocus
              />
            </HasPermissions>
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Assigned To')}>
            <HasPermissions
              permissions="work_orders.update"
              or={() => <span>{displayAssignee}</span>}
            >
              {(assigneesOptions.length > 0) ? (
                <Select
                  name="form-field-name"
                  value={this.state.assigned}
                  options={assigneesOptions}
                  onChange={value => this.handleChange(value, 'assigned')}
                  clearable={false}
                  openAfterFocus
                />
              ) :
                (
                  <span className="uk-text-muted uk-text-italic">{this.props.t('No staff assigned.')}</span>
                )}
            </HasPermissions>
          </GenericFormItem>
        </div>
      );
      if (sortedWorkorderComments.length > 0) {
        const commentList = sortedWorkorderComments.map((comment, idx) => (
          <Comment
            key={`comment-${idx}`}
            comment={comment}
            addModalControl
            onShowModal={(setModalInfo) => {
              this.setState({
                showCommentModal: true,
                modalInfo: setModalInfo,
              });
            }}
          />
        ));

        if (tempComment !== null) {
          let tempAttachment = { size: null, name: null, preview: null };
          if (tempComment.attachment) {
            tempAttachment = tempComment.attachment;
          }
          commentList.unshift((
            <Comment
              key="pending-comment"
              comment={{
                attachment_size: tempAttachment.size || null,
                attachment_name: tempAttachment.name || null,
                attachment_url: tempAttachment.preview || null,
                text: tempComment.text,
                has_attachment: _.has(tempComment, 'attachment'),
                _created: 'pending',
                created_by: {
                  id: user.id,
                  full_name: `${user.attributes.first_name} ${user.attributes.last_name}`,
                },
              }}
              addModalControl
              onShowModal={(setModalInfo) => {
                this.setState({
                  showCommentModal: true,
                  modalInfo: setModalInfo,
                });
              }}
              className="pending"
            />
          ));
        }

        comments = (
          <ul className="md-list">
            {commentList}
          </ul>
        );
      } else {
        comments = (
          <span className="uk-text-italic">{this.props.t('No comments')}.</span>
        );
      }
      workorderCommentsInfo = (
        <div>
          <AddAttachment
            itemId={workorderId}
            onAddAttachments={attachments => this.handleAddAttachments(attachments)}
            className="md-card-content-fab-spacer"
            hintText={this.props.t('Add new comment')}
            addDescription
            addFile
          />
          <h3 className="heading_b">{this.props.t('Comments List')}</h3>
          <SortPills
            activeOption={sortComments}
            options={[
              { value: 'asc', label: this.props.t('Ascending') },
              { value: 'desc', label: this.props.t('Descending') },
            ]}
            onChange={(changeSortComments) => {
              this.setState({
                sortComments: changeSortComments,
              });
            }}
          />
          {comments}
        </div>
      );

      const renderTasks = tasks => _.map(tasks, (task, key) => (
        <ListItem
          key={key}
          onClick={() => this.checkTask(task, !task.is_completed)}
        >
          <Checkbox
            label={this.props.t(task.task_label)}
            value={task.task_name}
            checked={task.is_completed}
          />
        </ListItem>
      ));

      const renderDisabledTasks = tasks => _.map(tasks, (task, key) => (
        <ListItem
          key={key}
        >
          <Checkbox
            label={this.props.t(task.task_label)}
            checked={task.is_completed}
            disabled
          />
        </ListItem>
      ));

      const renderTaskGroups = (tasks, groups, statusState) => groups.map((taskGroup) => {
        const filteredTasks = tasks.filter(task => task.task_group === taskGroup);
        const groupTitle = taskGroup || 'Tasks';
        const items = statusState === 'in_progress' ? renderTasks(filteredTasks) : renderDisabledTasks(filteredTasks);

        return (
          <List key={groupTitle}>
            <ListItem
              key={groupTitle}
              primaryText={groupTitle}
              primaryTogglesNestedList="true"
              nestedItems={items}
              initiallyOpen={groups.length === 1}
            />
          </List>
        );
      });

      if (workorderTasks && workorderTasks.length) {
        workorderTasksInfo = renderTaskGroups(workorderTasks, taskGroups, status);
      } else {
        workorderTasksInfo = (<h3 className="heading_b">{this.props.t('No tasks for this work order')}</h3>);
      }

      if (activeTab === 'details') {
        workorderFooterInfo = (
          <div className="md-card-footer uk-text-right">
            <button type="button" className="md-btn" onClick={() => this.goBackToList()}>{this.props.t('Back To List')}</button>
            <button
              type="submit"
              className={`md-btn md-btn-wave-light waves-effect waves-button waves-light ${(submitButtonDisabled === true) ? 'disabled' : 'md-btn-primary'}`}
              disabled={submitButtonDisabled}
              onClick={evt => this.handleSubmitTouchTap(evt)}
            >
              {this.props.t('Update')}
            </button>
            <div className="md-card-footer-float-left">
              <Link
                to={`/access/workorders/${this.props.workorderId}/edit`}
                className="md-btn md-btn-icon md-btn-flat md-btn-wave-light waves-effect waves-button waves-light md-btn-flat-primary"
              >
                <i className="material-icons">&#xE3C9;</i>
                {this.props.t('Edit')}
              </Link>
            </div>
          </div>
        );
      } else {
        workorderFooterInfo = (
          <div className="md-card-footer uk-text-right">
            <button type="button" className="md-btn" onClick={() => this.goBackToList()}>{this.props.t('Back To List')}</button>
          </div>
        );
      }

      // Filter tabs that active for this work order
      const activeTabs = AVAILABLE_TABS.filter((item) => {
        let isTabActive = true;
        if (item.tab === 'tasks' && !workorderTasks) {
          isTabActive = false;
        }
        return isTabActive;
      });

      workorderDetail = (
        <div id={workorder._id} className={detailsCardCls.join(' ')}>
          <div className="md-card-toolbar">
            <div className="md-card-toolbar-actions">
              <Channel channel={workorder.channel} color={workorder.dashboardColor} />
            </div>
            <h3 className="md-card-toolbar-heading-text">
              #{workorder.number}
            </h3>
          </div>
          <div className="md-card-content">
            <Tab
              tabs={activeTabs}
              activeTab={activeTab}
              onChange={(tab) => {
                this.handleResourceViewChange(tab);
              }}
              content={{
                details: workorderDetailInfo,
                comments: workorderCommentsInfo,
                tasks: workorderTasksInfo,
              }}
            />
          </div>
          {workorderFooterInfo}

        </div>
      );
    }

    if (modalInfo.src) {
      modal = (
        <Modal
          open={showCommentModal}
          lightbox
          onClose={() => {
            this.setState({
              showCommentModal: false,
            });
          }}
        >
          <ModalImage src={modalInfo.src} alt={modalInfo.alt || ''} />
          <ModalCaption>
            {modalInfo.caption}
          </ModalCaption>
        </Modal>
      );
    }

    return (
      <Screen title={this.props.t('Work Orders')} helpUrl="#wo">
        <div className="WorkorderDetail">
          <div className="uk-grid uk-flex-center">
            <div className="uk-width-small-4-5 uk-width-mobile-1-1">
              {workorderDetail}
            </div>
          </div>
          {modal}
        </div>
      </Screen>
    );
  }
}

WorkorderDetail.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  workorderId: PropTypes.string.isRequired,
  workorder: PropTypes.shape({
    _id: PropTypes.string,
    status: PropTypes.string,
    channel: PropTypes.string,
    type: PropTypes.string,
    severity: PropTypes.string,
    label: PropTypes.string,
    room: PropTypes.string,
    epochs: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    })),
    body: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    _created: PropTypes.string,
    assigned: PropTypes.objectOf(PropTypes.any),
    user_comment: PropTypes.string,
  }),
  workorderComments: PropTypes.arrayOf(PropTypes.object),
  workorderTasks: PropTypes.arrayOf(PropTypes.object),
  channels: PropTypes.arrayOf(PropTypes.object),
  workorderConfigs: PropTypes.arrayOf(PropTypes.object),
  staffList: PropTypes.arrayOf(PropTypes.object),
  // filterLocations: React.PropTypes.func,
  // dataFilters: React.PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    hash: PropTypes.string,
  }),
  processRequest: PropTypes.func,
  processResourceRequest: PropTypes.func,
  updateWorkorder: PropTypes.func,
  createWorkorderComment: PropTypes.func,
  history: HistoryType,
  user: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
  }),
  // eslint-disable-next-line
  lastAction: PropTypes.shape({
    id: PropTypes.string,
    configType: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  taskGroups: PropTypes.arrayOf(PropTypes.string),
  notify: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  let locations = [];
  let workorder;
  let workorderComments = [];
  let workorderConfigs = [];
  let user = {};
  let workorderTasks = [];
  let status = '';

  const {
    match: {
      params: {
        workorderId,
      },
    },
  } = ownProps;

  const actionType = state.action.type;
  const lastAction = state.api.lastAction;

  const {
    session: {
      channels,
    },
    affiliates: {
      staffList,
    },
  } = state;

  if (state.ticket.work_order) {
    workorder = _.find(state.ticket.work_order._items, { _id: workorderId });
    workorderTasks = workorder && workorder.checklist;
    status = workorder && workorder.status;
  }
  if (state.ticket.comment) {
    workorderComments = _.sortBy(_.filter(state.ticket.comment._items, { work_order_id: workorderId }), item => moment(item._created).toDate().getTime());
  }

  if (state.ticket.work_order_config) {
    workorderConfigs = state.ticket.work_order_config._items;
  }
  if (state.api.GemsRooms) {
    locations = state.api.GemsRooms.data;
  }
  if (state.session.user) {
    user = state.session.user;
  }

  const taskGroups = workorderTasks ? workorderTasks
    .map(item => item.task_group)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort() : null;

  return {
    workorderId,
    user,
    actionType,
    locations,
    workorder,
    workorderComments,
    channels,
    workorderConfigs,
    staffList,
    lastAction,
    workorderTasks,
    status,
    taskGroups,
  };
};

const mapDispatchToProps = dispatch => ({
  processRequest() {
    dispatch(actions.retrieveWorkorderConfigs());
  },
  processResourceRequest(workorderId) {
    dispatch(actions.retrieveWorkorderById(workorderId));
    dispatch(actions.retrieveWorkorderComments(workorderId));
    dispatch(actions.retrieveStaffList());
  },
  updateWorkorder(workorderId, payload) {
    dispatch(actions.updateWorkorder(workorderId, payload));
  },
  createWorkorderComment(workorderId, payload) {
    const refreshData = true;
    dispatch(actions.createWorkorderComment(workorderId, payload, refreshData));
  },
  notify(message, type) {
    dispatch(actions.showNotification(message, true, {
      type,
      location: 'bottom-center',
      showClose: true,
    }));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(WorkorderDetail));



// WEBPACK FOOTER //
// ./src/views/workorders/WorkorderDetail.js